import { render, staticRenderFns } from "./TicketQuickFilters.vue?vue&type=template&id=f88b9fc6&"
import script from "./TicketQuickFilters.vue?vue&type=script&lang=ts&"
export * from "./TicketQuickFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f88b9fc6')) {
      api.createRecord('f88b9fc6', component.options)
    } else {
      api.reload('f88b9fc6', component.options)
    }
    module.hot.accept("./TicketQuickFilters.vue?vue&type=template&id=f88b9fc6&", function () {
      api.rerender('f88b9fc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ticket/TicketQuickFilters.vue"
export default component.exports